import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { navActionCreators } from '../../../stores/lis-nav-store';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import '../../../stylesheets/lis-public-view/public-view.css';

class ResourcesComponent extends React.Component {
    constructor(props) {
        super(props)

    }

    render() {
        const { session, isAuthenticated } = this.props;

        const params = {
            selectedSession: this.props.session ? this.props.session.SessionID : '',
            currentStatus: false,
            includeFailed: true,
            allLegislation: true,
            uniqueSearch: Math.random(),
        };
        const json = JSON.stringify(params);
        const queryString = window.btoa(json);

        return (
            <div>
                <h3 className="homepage-header">Bills & Resolutions</h3>
                <hr />
                {!this.props.isLoaded ?
                    <div className="center-spinner spinner small-height" />
                    :
                    <section className="homepage-links">
                        <span>{session.selectedSession.SessionYear + " Session: "}
                            <Link to="/bill-search">Bills by Category</Link>
                            <span style={{ margin: '0px 5px', color: '#ccc' }}>|</span>
                            <Link to={"/bill-search?q=" + queryString}>All Legislation</Link>
                        </span>
                        <span>Budget Bill: <a href={"http://budget.lis.virginia.gov/"}>State Budget</a></span>
                        <span>Bill Indexes: <a href={"https://index.lis.virginia.gov?ses=" + session.selectedSession.SessionCode}>Cumulative Index</a></span>
                        <Link to={isAuthenticated ? "/bill-search" : "/login"}>LOBBYIST in a BOX</Link>
                    </section>
                }
                <h3 className="homepage-header" style={{ marginTop: "28px" }}>Virginia Law</h3>
                <hr />
                <section className="homepage-links">
                    <a href="https://law.lis.virginia.gov/vacode/">Code of Virginia</a>
                    <a href="https://law.lis.virginia.gov/admincode/">Virginia Administrative Code</a>
                    <a href="https://law.lis.virginia.gov/constitution/">Constitution of Virginia</a>
                </section>
                <h3 className="homepage-header" style={{ marginTop: "28px" }}>Legislative Resources</h3>
                <hr />
                <section className="homepage-links">
                    <a href="https://liaison.lis.virginia.gov/">State Agency Legislative Liaisons</a>
                    <a href="https://rga.lis.virginia.gov/">Reports to the General Assembly</a>
                    <a href="http://dls.virginia.gov/pubs_calendar.html">Procedural Calendars</a>
                </section>
            </div>
        )
    }
}

export default connect(
    (state) => {
        const { nav, session } = state;
        return {
            nav,
            session
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, navActionCreators, sessionActionCreators), dispatch)
        }
    }
)(ResourcesComponent)
